/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PublishPluginsResult = {
  /**
   * The URL of the published GitHub repository.
   */
  repoUrl: string;
};

/** @internal */
export const PublishPluginsResult$inboundSchema: z.ZodMiniType<
  PublishPluginsResult,
  unknown
> = z.pipe(
  z.object({
    repo_url: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "repo_url": "repoUrl",
    });
  }),
);

export function publishPluginsResultFromJSON(
  jsonString: string,
): SafeParseResult<PublishPluginsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PublishPluginsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PublishPluginsResult' from JSON`,
  );
}
